<script lang="ts">
  import { Chart, Svg, Axis, Bars, Tooltip, Highlight } from 'layerchart';
  import { scaleBand } from 'd3-scale';

  interface Props {
    seoTrend: { labels: string[]; spider_visits: number[] };
    t: (path: string) => string;
  }

  let { seoTrend = { labels: [], spider_visits: [] }, t }: Props = $props();

  let formattedSeoData = $derived(
    (seoTrend?.labels || []).map((label, index) => ({
      date: String(label || ''),
      visits: Number(seoTrend?.spider_visits?.[index] ?? 0)
    }))
  );
</script>

<div class="rounded-xl border bg-card p-5 shadow-sm flex flex-col">
  <div class="mb-4">
    <h3 class="text-sm font-semibold">{t('dashboard.charts.spider_trend_title')}</h3>
    <p class="text-xs text-muted-foreground">{t('dashboard.charts.spider_trend_desc')}</p>
  </div>
  
  <div class="h-56 w-full relative">
    {#if formattedSeoData && formattedSeoData.length > 0}
      <Chart
        data={formattedSeoData}
        x="date"
        y="visits"
        xScale={scaleBand().padding(0.2)}
        yDomain={[0, Math.max(10, ...formattedSeoData.map(d => d.visits ?? 0))]}
        padding={{ top: 10, bottom: 24, left: 28, right: 10 }}
        tooltip={{ mode: 'band' }}
      >
        <Svg>
          <Axis placement="bottom" grid class="text-[10px] text-muted-foreground" />
          <Axis placement="left" grid class="text-[10px] text-muted-foreground" />

          <Bars class="fill-primary/80 hover:fill-primary rx-1 transition-all" />

          <Highlight bar class="fill-primary/10" />
        </Svg>

        <Tooltip.Root>
          {#snippet children({ data })}
            {#if data}
              <Tooltip.Header>{data.date ?? ''}</Tooltip.Header>
              <Tooltip.List>
                <Tooltip.Item label={t('dashboard.charts.spider_visits')} value={data.visits ?? 0} class="text-primary" />
              </Tooltip.List>
            {/if}
          {/snippet}
        </Tooltip.Root>
      </Chart>
    {:else}
      <div class="flex h-full items-center justify-center text-xs text-muted-foreground">
        {t('dashboard.charts.no_spider_data')}
      </div>
    {/if}
  </div>
</div>